/*
 CenterPanel

 Definicja aplikacji 
 Ekran główny  - zobacz
 // https://material-ui.com/getting-started/page-layout-examples/

 Dla testów:
    - testy komponentów: w miejsce <Booking /> wstaw  <ComponentTest />
 Todo:
  - nie skończone logowanie / wylogowywanie
  
 historia: 
  04-2019 JW - start
*/

import * as React from 'react';
import { connect } from 'react-redux';
import { withStyles, Theme, WithStyles, MuiThemeProvider } from '@material-ui/core/styles';

import CenterTable from './CenterTable';
import CenterTableBez from './CenterTableBez+2-2';
//import CenterTableNumerami from './CenterTableNumerami';
//import CenterTableRodzajami from './CenterTableRodzajami';
import CONFIG from '../../cfg/config';
import {  AppState, store, Actions, IPageState } from '../../appredux';
import { sendErrorLog } from '../common/helpers';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { Fab } from '@material-ui/core';
import { createTheme } from '@mui/material';
import { ObiectRoomNumer } from 'api';
import theme from 'themes/themes';

const FabTheme = createTheme({
  palette: {
    primary: {
      main: "rgb(192, 192, 192)",
      //dark: "#347173"
    },
  },
});

interface CenterPanelProps {
  page: IPageState,
  expanded: boolean,
  expand: () => void,
  windowWidth: number,
}

interface ComponentState {
}

class CenterPanel extends React.Component<CenterPanelProps & WithStyles<typeof styles>, ComponentState> {

  constructor(props: any) {
    super(props, {});
    this.state = {
    }
    store.dispatch(Actions.pageState.addFcmLogMessage("okno glowne grafik", 0))
    sendErrorLog("1", "1", "okno glowne grafik")
  }

  //PM 2021-07-28
  render() {
    const { classes } = this.props;

    let grafikNumeryLength = this.props.page.grafikNumery.filter((x: ObiectRoomNumer) => x.typ === 2).length

    return (
      <React.Fragment>
        {/* Stary grafik rodzajami */}
        {/* Grafik rodzajami */}
        {/* Grafik numerami */}

        {/* {CONFIG.grafikiRodzaj === "0" || CONFIG.grafikiRodzaj === "3" ?
          <CenterTable windowWidth={this.props.windowWidth} expanded={this.props.expanded} />
          : CONFIG.grafikiRodzaj === "1" ?
            <CenterTableRodzajami windowWidth={this.props.windowWidth} expanded={this.props.expanded} />
            : CONFIG.grafikiRodzaj === "2" ?
              <CenterTableNumerami windowWidth={this.props.windowWidth} expanded={this.props.expanded} />
              : null} */}

        {/* <CenterTable windowWidth={this.props.windowWidth} expanded={this.props.expanded} /> */}
        <CenterTableBez windowWidth={this.props.windowWidth} expanded={this.props.expanded} />

        {/* {this.props.page.roomsOld.length > 7 || this.props.page.rooms.length > 7 || grafikNumeryLength > 7 ?
         
           <MuiThemeProvider theme={theme}>
            <Fab
              color={"secondary"}
              //aria-label="map"
              onClick={() => this.props.expand()}
              style={{}}
              className={classes.fab}
            >
              {this.props.expanded ?
                <KeyboardArrowUpIcon className={classes.arrow} />
                :
                <KeyboardArrowDownIcon className={classes.arrow} />}
            </Fab>
           </MuiThemeProvider>
          
               : null} */}
      </React.Fragment>
    );
  }
}

const styles = (theme: Theme) => ({
  arrow: {
    cursor: "pointer",
    color: "white",//theme.palette.primary.main,
    //padding: "4px",
    //position: 'absolute' as 'absolute',
    //bottom: '8px',
    //bottom: '4px',
    //right: '78px',
    //right: '66px',
    //width: '60px',
    fontSize: '1.5rem',
    width: "30px",
    height: "30px",
  },
  fab: {
    zIndex: 1000,
    position: "absolute" as "absolute",
    top: "15px",
    right: "15px",
    width: "35px",
    height: "35px",
    //backgroundColor: "rgb(192, 192, 192)",
  },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});


export default connect(mapStateToProps)(withStyles(styles)(CenterPanel));
